import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
  title?: string;
  message: string;
  type?: 'success' | 'error' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new BehaviorSubject<ToastMessage | null>(null);
  toast$ = this.toastSubject.asObservable();

  showToaster(title: string, message: string, type?: 'success' | 'error' | 'info') {
    const data = {
      title: title,
      message: message,
      type: type,
    }

    this.toastSubject.next(data);

    setTimeout(() => {
      this.clear();
    }, 3000);
  }

  clear() {
    this.toastSubject.next(null);
  }
}
